import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Link } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import { getInstanceDrillDownData } from "./getInstanceDrillDownData";
import { SpotPrice } from "@aws-sdk/client-ec2";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";

export const InstanceDrillDown = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [instanceData, setInstanceData] = useState<SpotPrice[]>([]);

  let { instanceType } = useParams();

  const fetchData = async (instanceTypeData: string) => {
    setIsLoading(true);

    const data = await getInstanceDrillDownData(instanceTypeData);

    setInstanceData(data);
    setIsLoading(false);
  };

  useEffect(() => {
    if (instanceType) {
      void fetchData(instanceType);
    }
  }, [instanceType]);

  return (
    <>
      <Breadcrumbs aria-label="breadcrumb">
        <Link underline="hover" color="inherit" href="/">
          Spot Instances
        </Link>
        <Link underline="hover" color="inherit" href={`/${instanceType}`}>
          {instanceType}
        </Link>
      </Breadcrumbs>
      <Card sx={{ width: "100%", height: "100%" }}>
        <CardHeader title={`All AWS Spot prices for ${instanceType}`} />
        <CardContent sx={{ height: "calc(100% - 100px)" }}>
          <DataGrid
            sx={{
              ".MuiDataGrid-columnHeader:focus,.MuiDataGrid-columnHeader:focus-within,.MuiDataGrid-cell:focus,.MuiDataGrid-cell:focus-within":
                {
                  outline: "none",
                },
            }}
            loading={isLoading}
            paginationMode="client"
            rowCount={instanceData.length}
            rowHeight={40}
            disableColumnFilter={true}
            disableColumnSelector={true}
            disableColumnMenu={true}
            initialState={{
              pagination: {
                paginationModel: { pageSize: 50 },
              },
              sorting: {
                sortModel: [{ field: "SpotPrice", sort: "asc" }],
              },
            }}
            columns={[
              {
                field: "ProductDescription",
                headerName: "Operating System",
                flex: 1,
              },
              {
                field: "SpotPrice",
                headerName: "Spot Price",
                type: "number",
                flex: 1,
                align: "left",
                headerAlign: "left",
                valueGetter: (instanceType) => instanceType.row?.SpotPrice,
                valueFormatter: (data) => `$${data.value}`,
              },
              {
                field: "Region",
                headerName: "Region",
                flex: 1,
                valueGetter: (instanceType) =>
                  instanceType.row?.AvailabilityZone?.slice(0, -1),
              },
              {
                field: "AvailabilityZone",
                headerName: "Availability Zone",
                flex: 1,
              },
            ]}
            rows={instanceData.map((spotPrice) => ({
              id: `${spotPrice.ProductDescription}${spotPrice.AvailabilityZone}`,
              ...spotPrice,
            }))}
          />
        </CardContent>
      </Card>
    </>
  );
};
